import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { useState } from "react";
import "./styles/App.css";

import { DataProvider } from "./context/DataContext";
import LandingPage from "./UI/Dashboard/LandingPage";
import Confronto from "./components/Confronto/Confronto";
import Singola_Analisi from "./UI/Graph/Singola_Analisi";
import Semafix from "./UI/Semafix/Semafix";

function App() {
  return (
    <DataProvider>
      <Router>
        <div className="grid-container">
          <main className="main-container-App">
            <Routes>
              <Route path="/confronto" element={<Confronto />} />
              <Route path="/analisi" element={<Singola_Analisi />} />
              <Route path="/editor" element={<Semafix />} />
            </Routes>
          </main>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
